// src/json/servicesOverview.json
export const servicesOverviewCommercialsnowRemoval = {
    eyebrow: "OUR SNOW & ICE REMOVAL",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "24/7 Snow Clearing & Plowing",
            description: "Timely and effective snow removal for parking lots, sidewalks, driveways, and building entrances."
        },
        {
            title: "De-Icing & Ice Management",
            description: "Application of eco-friendly de-icing agents to prevent ice buildup and reduce slip-and-fall hazards."
        },
        {
            title: "Rooftop Snow Removal",
            description: "Safe and strategic removal of heavy snow accumulation to prevent structural strain, ice dams, and leaks."
        },
        {
            title: "Pathway & Stairway Clearing",
            description: "Ensuring safe and accessible walkways, emergency exits, and staircases for tenants and visitors."
        },
        {
            title: "Emergency Snow & Ice Response",
            description: "Rapid response teams ready to handle unexpected snowstorms and ice buildup to minimize disruptions."
        }
    ],
    imageUrl: "/assets/imgs/services/6CommercialsnowRemoval/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  